import script from "./PhaseComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PhaseComponent.vue?vue&type=script&setup=true&lang=js"

import "./PhaseComponent.vue?vue&type=style&index=0&id=75a175ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75a175ca"]])

export default __exports__